import { render, staticRenderFns } from "./ModalPaymentByProvidersInfo.vue?vue&type=template&id=13235796&scoped=true&"
import script from "./ModalPaymentByProvidersInfo.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentByProvidersInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaymentByProvidersInfo.vue?vue&type=style&index=0&id=13235796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13235796",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
